import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AccountsModule } from './../accounts/accounts.module';
import { AccessResolver } from './resolver/access.resolver';
import { MnApplicationsDataService } from './services/applications.data.service';
import { GaApplicationsService } from './services/applications.service';
import { ApplicationsEffects } from './store/applications.effects';
import { applicationsReducer } from './store/applications.store';

@NgModule({
    imports: [
        // Angular and vendors
        CommonModule,
        StoreModule.forFeature('applications', applicationsReducer),
        EffectsModule.forFeature([ApplicationsEffects]),
        // pg
        AccountsModule
    ],
    declarations: [],
    providers: [
        MnApplicationsDataService,
        GaApplicationsService
    ]
})
export class ApplicationsModule {
    static forRoot(): ModuleWithProviders<ApplicationsModule> {
        return {
            ngModule: ApplicationsModule,
            providers: [
                AccessResolver
            ]
        };
    }
}
